import { Button, Modal } from '@next-nx/shared-ui/atoms'
import { useTrans, useTealium, useSite } from '@next-nx/hooks'
import { getTimestamp, isLandingCarrozzerie } from '@next-nx/utils'
import React from 'react'
import styles from './RichiestaPreventivoThankYouModal.module.sass'
import { LandingType, TypDataTracking } from '@next-nx/utils/types'
import { useSelector } from 'react-redux'
import { AGENZIE, CARROZZERIE, NUOVAMOBILITA } from '@next-nx/utils/settings'
interface Props {
  open: boolean
  setOpen: (v: boolean) => void
  status: string | undefined
  className?: string
  trackingData?: TypDataTracking
}

const RichiestaPreventivoThankYouModal = (props: Props) => {
  const {
    open = false,
    setOpen = () => {},
    status = undefined,
    className = '',
    trackingData = {},
  } = props
  const t = useTrans()
  const { linkDataLayer } = useTealium()

  const { landing }: { landing: LandingType } = useSelector((state: any) => state?.landing)
  const siteId = landing?.siteId?.toString()
  const site = useSite(siteId)

  const handleTracking = () => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'richiesta_preventivo',
      action_tech: 'click',
      action_type: 'chiudi_thankyou_page',
      action_timestamp,
      action_effect: 'chiudi_form_richiesta_preventivo_typ',
      position:
        site === NUOVAMOBILITA || site === AGENZIE || site === CARROZZERIE ? 'in_page' : 'popup',
      market: isLandingCarrozzerie(site) ? 'b2b' : 'b2c',
      id_agenzia: trackingData.id_agenzia ? trackingData.id_agenzia : '-',
      id_carrozzeria: trackingData.id_carrozzeria ? trackingData.id_carrozzeria : '-',
    })
  }

  return (
    <Modal
      open={open}
      setOpen={(v) => {
        handleTracking()
        setOpen(v)
      }}
      closeButton
      title={
        status === 'error'
          ? t("C'è stato un errore nell'invio della tua richiesta di preventivo")
          : t('La tua richiesta di preventivo è stata inviata con successo!')
      }
      description={
        status === 'error'
          ? t('Ci scusiamo per il disagio, ti invitiamo a riprovare più tardi.')
          : t(
              'Ti ringraziamo per il tempo dedicatoci, sarai ricontattato da un nostro consulente per personalizzare la tua richiesta.'
            )
      }
      buttons={
        <Button
          label={t('Chiudi')}
          onClick={() => {
            handleTracking()
            setOpen(false)
          }}
        />
      }
      className={`${styles.root} ${className}`}
    />
  )
}

export default RichiestaPreventivoThankYouModal
